import React, { useState, useEffect } from 'react';
import axios from 'axios';

const TenantAdminDashboard = () => {
  const [ticketTypes, setTicketTypes] = useState([]);
  const [bookings, setBookings] = useState([]);
  const [showTicketForm, setShowTicketForm] = useState(false);
  const [showPaymentForm, setShowPaymentForm] = useState(false);
  const [ticketForm, setTicketForm] = useState({
    name: '', city: 'bhubaneswar', category: 'park_ticket', description: '', price: '', validity: { type: 'days', duration: 1 }
  });
  const [paymentForm, setPaymentForm] = useState({
    gateway: 'payu', config: {}
  });

  useEffect(() => {
    fetchTicketTypes();
    fetchBookings();
  }, []);

  const fetchTicketTypes = async () => {
    try {
      const response = await axios.get('/api/tickets', {
        headers: { 'x-tenant-id': localStorage.getItem('tenantId') }
      });
      setTicketTypes(response.data.ticketTypes);
    } catch (error) {
      console.error('Error fetching ticket types:', error);
    }
  };

  const fetchBookings = async () => {
    try {
      const response = await axios.get('/api/bookings', {
        headers: { 
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          'x-tenant-id': localStorage.getItem('tenantId')
        }
      });
      setBookings(response.data.bookings);
    } catch (error) {
      console.error('Error fetching bookings:', error);
    }
  };

  const handleTicketSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post('/api/tickets', ticketForm, {
        headers: { 
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          'x-tenant-id': localStorage.getItem('tenantId')
        }
      });
      setShowTicketForm(false);
      setTicketForm({ name: '', city: 'bhubaneswar', category: 'park_ticket', description: '', price: '', validity: { type: 'days', duration: 1 } });
      fetchTicketTypes();
    } catch (error) {
      console.error('Error creating ticket type:', error);
    }
  };

  const handlePaymentSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post('/api/tenants/payment-gateway', paymentForm, {
        headers: { 
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          'x-tenant-id': localStorage.getItem('tenantId')
        }
      });
      setShowPaymentForm(false);
      alert('Payment gateway configured successfully!');
    } catch (error) {
      console.error('Error configuring payment gateway:', error);
    }
  };

  return (
    <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '24px' }}>
        <img 
          src="/android-chrome-192x192.png" 
          alt="Tiket Jini Logo" 
          style={{
            width: '64px',
            height: '64px',
            borderRadius: '16px',
            objectFit: 'cover'
          }}
        />
        <div>
          <h1 style={{ margin: 0, fontSize: '2rem', fontWeight: '700' }}>Tenant Admin Dashboard</h1>
          <p style={{ margin: 0, color: '#666', fontSize: '1rem' }}>Manage your park tickets and bookings</p>
        </div>
      </div>
      
      <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
        <button 
          onClick={() => setShowTicketForm(!showTicketForm)}
          style={{ padding: '10px 20px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '4px' }}
        >
          {showTicketForm ? 'Cancel' : 'Add Ticket Type'}
        </button>
        <button 
          onClick={() => setShowPaymentForm(!showPaymentForm)}
          style={{ padding: '10px 20px', backgroundColor: '#28a745', color: 'white', border: 'none', borderRadius: '4px' }}
        >
          Configure Payment Gateway
        </button>
      </div>

      {showTicketForm && (
        <form onSubmit={handleTicketSubmit} style={{ marginBottom: '30px', padding: '20px', border: '1px solid #ddd', borderRadius: '4px' }}>
          <h3>Create Ticket Type</h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '15px' }}>
            <input
              type="text"
              placeholder="Ticket Name"
              value={ticketForm.name}
              onChange={(e) => setTicketForm({...ticketForm, name: e.target.value})}
              required
              style={{ padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
            />
            <select
              value={ticketForm.city}
              onChange={(e) => setTicketForm({...ticketForm, city: e.target.value})}
              style={{ padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
            >
              <option value="bhubaneswar">Bhubaneswar</option>
              <option value="cuttack">Cuttack</option>
              <option value="rourkela">Rourkela</option>
              <option value="berhampur">Berhampur</option>
              <option value="sambalpur">Sambalpur</option>
              <option value="puri">Puri</option>
              <option value="balasore">Balasore</option>
              <option value="baripada">Baripada</option>
              <option value="jharsuguda">Jharsuguda</option>
              <option value="jeypore">Jeypore</option>
            </select>
            <select
              value={ticketForm.category}
              onChange={(e) => setTicketForm({...ticketForm, category: e.target.value})}
              style={{ padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
            >
              <option value="park_ticket">Park Ticket</option>
              <option value="parking_ticket">Parking Ticket</option>
              <option value="banquet_hall">Banquet Hall</option>
              <option value="event_ticket">Event Ticket</option>
              <option value="other">Other</option>
            </select>
            <input
              type="number"
              placeholder="Price"
              value={ticketForm.price}
              onChange={(e) => setTicketForm({...ticketForm, price: e.target.value})}
              required
              style={{ padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
            />
            <input
              type="number"
              placeholder="Validity Duration"
              value={ticketForm.validity.duration}
              onChange={(e) => setTicketForm({...ticketForm, validity: {...ticketForm.validity, duration: e.target.value}})}
              style={{ padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
            />
            <textarea
              placeholder="Description"
              value={ticketForm.description}
              onChange={(e) => setTicketForm({...ticketForm, description: e.target.value})}
              style={{ padding: '8px', border: '1px solid #ddd', borderRadius: '4px', gridColumn: '1 / -1' }}
            />
          </div>
          <button type="submit" style={{ marginTop: '15px', padding: '10px 20px', backgroundColor: '#28a745', color: 'white', border: 'none', borderRadius: '4px' }}>
            Create Ticket Type
          </button>
        </form>
      )}

      {showPaymentForm && (
        <form onSubmit={handlePaymentSubmit} style={{ marginBottom: '30px', padding: '20px', border: '1px solid #ddd', borderRadius: '4px' }}>
          <h3>Configure Payment Gateway</h3>
          <select
            value={paymentForm.gateway}
            onChange={(e) => setPaymentForm({...paymentForm, gateway: e.target.value})}
            style={{ padding: '8px', border: '1px solid #ddd', borderRadius: '4px', marginBottom: '15px', width: '200px' }}
          >
            <option value="payu">PayU</option>
            <option value="icici">ICICI</option>
            <option value="idfc">IDFC</option>
          </select>
          
          {paymentForm.gateway === 'payu' && (
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
              <input
                type="text"
                placeholder="Merchant Key"
                onChange={(e) => setPaymentForm({...paymentForm, config: {...paymentForm.config, merchantKey: e.target.value}})}
                style={{ padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
              />
              <input
                type="text"
                placeholder="Merchant Salt"
                onChange={(e) => setPaymentForm({...paymentForm, config: {...paymentForm.config, merchantSalt: e.target.value}})}
                style={{ padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
              />
            </div>
          )}
          
          <button type="submit" style={{ marginTop: '15px', padding: '10px 20px', backgroundColor: '#28a745', color: 'white', border: 'none', borderRadius: '4px' }}>
            Configure Gateway
          </button>
        </form>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '30px' }}>
        <div>
          <h3>Ticket Types</h3>
          {ticketTypes.map(ticket => (
            <div key={ticket._id} style={{ padding: '15px', border: '1px solid #ddd', borderRadius: '4px', marginBottom: '10px' }}>
              <h4>{ticket.name}</h4>
              <p><strong>City:</strong> {ticket.city}</p>
              <p><strong>Category:</strong> {ticket.category.replace('_', ' ')}</p>
              <p><strong>Price:</strong> ₹{ticket.price}</p>
              <p><strong>Status:</strong> {ticket.isActive ? 'Active' : 'Inactive'}</p>
            </div>
          ))}
        </div>

        <div>
          <h3>Recent Bookings</h3>
          {bookings.slice(0, 5).map(booking => (
            <div key={booking._id} style={{ padding: '15px', border: '1px solid #ddd', borderRadius: '4px', marginBottom: '10px' }}>
              <p><strong>Booking ID:</strong> {booking.bookingId}</p>
              <p><strong>Customer:</strong> {booking.customerDetails.name}</p>
              <p><strong>Amount:</strong> ₹{booking.totalAmount}</p>
              <p><strong>Status:</strong> {booking.status}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TenantAdminDashboard;